
import React, { useContext, useEffect, useRef } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const CustomCursor = () => {
  const { activeCursor } = useContext(ThemeContext);
  const cursorRef = useRef(null);
  const cursorImageRef = useRef(null);

  // Our cursor mappings using local files
  const CURSOR_MAPPINGS = {
    'cursor-cat': '/cursors/cat.png',
    'cursor-fox': '/cursors/fox.png',
    'cursor-dog': '/cursors/dog.png',
    'cursor-owl': '/cursors/owl.png',
    'cursor-sword': '/cursors/sword.png',
    'cursor-shield': '/cursors/shield.png',
    'cursor-potion': '/cursors/potion.png',
    'cursor-controller': '/cursors/controller.png'
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      // Make cursor element follow mouse
      if (cursorRef.current) {
        cursorRef.current.style.left = `${e.clientX}px`;
        cursorRef.current.style.top = `${e.clientY}px`;
      }
    };

    // Add mouse move listener
    window.addEventListener('mousemove', handleMouseMove);

    // Hide default cursor AND force all elements to use no cursor!
    let globalStyleElement = document.getElementById('custom-cursor-global-style');
    let cursorStyleElement = document.getElementById('custom-cursor-style');
    
    if (activeCursor) {
      // Global cursor hiding style
      if (!globalStyleElement) {
        globalStyleElement = document.createElement('style');
        globalStyleElement.id = 'custom-cursor-global-style';
        document.head.appendChild(globalStyleElement);
      }
      globalStyleElement.textContent = `
        *, *:hover, *:active, *:focus {
          cursor: none !important;
        }
      `;

      // Custom cursor container styles
      if (!cursorStyleElement) {
        cursorStyleElement = document.createElement('style');
        cursorStyleElement.id = 'custom-cursor-style';
        document.head.appendChild(cursorStyleElement);
      }
      cursorStyleElement.textContent = `
        .custom-cursor-container,
        .custom-cursor-container * {
          background: transparent !important;
          background-color: transparent !important;
          border: none !important;
          box-shadow: none !important;
          padding: 0 !important;
          margin: 0 !important;
          outline: none !important;
        }
      `;
    } else {
      // Clean up styles when no cursor is active
      if (globalStyleElement) globalStyleElement.remove();
      if (cursorStyleElement) cursorStyleElement.remove();
    }

    // Cleanup
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      const oldGlobalStyle = document.getElementById('custom-cursor-global-style');
      const oldCursorStyle = document.getElementById('custom-cursor-style');
      if (oldGlobalStyle) oldGlobalStyle.remove();
      if (oldCursorStyle) oldCursorStyle.remove();
    };
  }, [activeCursor]);

  if (!activeCursor) return null;

  const cursorUrl = CURSOR_MAPPINGS[activeCursor];

  return (
    <div
      ref={cursorRef}
      className="custom-cursor-container"
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '64px',
        height: '64px',
        pointerEvents: 'none', // Important: let clicks pass through
        zIndex: 99999,
        transform: 'translate(-50%, -50%)', // Center image on mouse position
        transition: 'none'
      }}
    >
      <img
        ref={cursorImageRef}
        src={cursorUrl}
        alt="Custom cursor"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
};

export default CustomCursor;
